import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';

export const COLUMNS = (t) => [
    {
        label: t('tools.live_url.traffic_by_country.country'),
        key: 'country',
        data: 'country',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{data}</strong>;
        },
    },
    {
        label: t('tools.live_url.traffic_by_country.searchImpressions'),
        key: 'search_impressions',
        data: 'search_impressions',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('tools.live_url.traffic_by_country.searchClicks'),
        key: 'search_clicks',
        data: 'search_clicks',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('tools.live_url.traffic_by_country.searchCTR'),
        key: 'search_ctr',
        data: 'search_ctr',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            const ctrValue = item.search_clicks / item.search_impressions;
            if (csvDownload) return ctrValue;

            return <strong>{numeral(ctrValue).format('0.00%')}</strong>;
        },
    },
    {
        label: t('tools.live_url.traffic_by_country.discoverImpressions'),
        key: 'discover_impressions',
        data: 'discover_impressions',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('tools.live_url.traffic_by_country.discoverClicks'),
        key: 'discover_clicks',
        data: 'discover_clicks',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('tools.live_url.traffic_by_country.discoverCTR'),
        key: 'discover_ctr',
        data: 'discover_ctr',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            const ctrValue = item.discover_clicks / item.discover_impressions;
            if (csvDownload) return ctrValue;

            return <strong>{numeral(ctrValue).format('0.00%')}</strong>;
        },
    },
];
